import { NgModule } from '@angular/core';
import {
  provideTransloco,
  TranslocoModule,
} from '@jsverse/transloco';
import { provideTranslocoPersistLang } from '@jsverse/transloco-persist-lang';

import { TranslocoHttpLoader } from './transloco-loader';
import { environment } from '../environments/environment';

import { supportedLangs } from 'src/i18n/config';

@NgModule({
  exports: [ TranslocoModule ],
  providers: [
    provideTransloco({
      config: {
        availableLangs: supportedLangs,
        defaultLang: 'en',
        fallbackLang: 'en',
        missingHandler: {
          useFallbackTranslation: true,
        },
        reRenderOnLangChange: true, // Support changing language at runtime.
        prodMode: environment.stage === 'prod',
      },
      loader: TranslocoHttpLoader,
    }),
    provideTranslocoPersistLang({
      storage: {
        useValue: localStorage,
      },
    }),
  ],
})
export class TranslocoRootModule { }
